<template>
  <div class="h-full">
    <template v-if="isShowUerInput">
      <el-tooltip
        :content="paperName"
        placement="top"
        effect="dark"
        :enterable="false"
        v-if="disabled"
      >
        <el-input size="small" :placeholder="placeholder" :value="paperName" disabled />
      </el-tooltip>
      <el-input
        v-else
        size="small"
        :placeholder="placeholder"
        :value="paperName"
        clearable
        @clear="clearName"
      >
        <template slot="append">
          <el-button type="primary" size="small" @click="initDialog">选择</el-button>
        </template>
      </el-input>
    </template>
    <el-dialog
      ref="dailog"
      append-to-body
      :close-on-click-modal="false"
      title="选择试卷"
      :visible.sync="showDialog"
      top="2vh"
      class="mid-dialog"
      v-dialogDrag
    >
      <div class="w-full h-full">
        <div class="mb-20px flex justify-between items-center">
          <div class="flex">
            <el-input
              size="small"
              class="mr-10px !w-50"
              placeholder="试卷名称/编号"
              maxlength="50"
              v-model="searchData.keywords"
              clearable
            ></el-input>
            <el-select
              v-model="searchData.paperCategory"
              size="small"
              class="mr-10px !w-50 mb-10px"
              placeholder="试卷分类"
              clearable
            >
              <el-option
                v-for="item in pagerTypeList"
                :key="item.value"
                :label="item.displayName"
                :value="Number(item.code)"
              ></el-option>
            </el-select>
            <el-button size="small" type="primary" @click="handleSearch()">搜索</el-button>
            <el-button size="small" @click="resetText()">重置</el-button>
          </div>
        </div>
        <el-table
          ref="table"
          :data="tableData"
          border
          stripe
          height="calc(100% - 120px)"
          v-loading="tableLoading"
          :highlight-current="true"
          @selection-change="handleSelection"
          @cell-click="cellClick"
          :row-key="getRowKeys"
        >
          <el-table-column
            :reserve-selection="multiple"
            type="selection"
            :selectable="selectable"
            width="50"
            v-if="multiple"
          ></el-table-column>
          <el-table-column
            type="index"
            label="序号"
            show-overflow-tooltip
            width="60"
          ></el-table-column>
          <el-table-column
            label="试卷编码"
            prop="paperCode"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column label="试卷名称" prop="paperName" show-overflow-tooltip>
          </el-table-column>
          <el-table-column label="试卷分类" prop="paperCategoryStr" show-overflow-tooltip>
          </el-table-column>
          <el-table-column label="试卷总分" prop="totalScore" width="180" show-overflow-tooltip>
          </el-table-column>
          <el-table-column label="创建时间" prop="creationTime" width="180" show-overflow-tooltip>
            <template slot-scope="scope">
              {{
                scope.row.creationTime &&
                  dayjs(scope.row.creationTime).format('YYYY-MM-DD HH:mm:ss')
              }}
            </template>
          </el-table-column>
        </el-table>
        <div class="flex justify-end mt-20px">
          <el-pagination
            background
            @size-change="tableSizeChange"
            @current-change="tableCurrentChange"
            :current-page.sync="pageConfig.SkipCount"
            layout="total, sizes, prev, pager, next, jumper"
            :page-size.sync="pageConfig.MaxResultCount"
            :total="total"
            :page-sizes="[15, 30, 45, 60, 75, 90]"
            :pager-count="5"
          >
          </el-pagination>
        </div>
      </div>
      <div slot="footer" class="text-center" v-if="multiple">
        <el-button type="primary" size="small" @click="handleOk" icon="iconfont icon-save">
          <span>确定</span>
        </el-button>
        <el-button size="small" @click="showDialog = false" icon="iconfont icon-close">
          <span>取消</span>
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script type="text/babel">
import { ExamPaperApi } from '@wiz-api/exam-management'
import dayjs from 'dayjs'
import utils from '@/components/safety/enumField/utils'

const examPaperApi = new ExamPaperApi()
export default {
  name: 'multiple-exam-select',
  components: {},
  props: {
    // 是否显示内置选择输入框
    isShowUerInput: {
      type: Boolean,
      default: true,
    },
    placeholder: {
      default: '请选择人员',
    },
    // 是否禁用选择按钮
    disabled: {
      type: Boolean,
      default: false,
    },
    value: {
      default: '',
    },
    // 是否多选
    multiple: {
      type: Boolean,
      default: true,
    },
    // 禁止勾选id集合
    disabledIds: {
      default: () => {
        return []
      },
    },
  },
  model: {
    prop: 'value',
    event: 'change',
  },
  data() {
    return {
      pagerTypeList: [],
      paperName: '',
      searchData: {
        keywords: '',
        paperCategory: '',
      },
      tableLoading: false,
      pageConfig: {
        MaxResultCount: 15,
        SkipCount: 1,
      },
      tableData: [],
      pageNo: 1,
      pageSize: 10,
      total: 0,
      showDialog: false,
      selectionData: [],
    }
  },
  computed: {},
  watch: {
    value: {
      handler(ids) {
        if (!ids) {
          this.paperName = ''
          this.$nextTick(() => {
            this.$refs.table.clearSelection()
          })
        } else {
          this.getPaperName()
        }
      },
      immediate: true,
    },
    showDialog(value) {
      if (value && !this.isShowUerInput) {
        this.initDialog()
      }
    },
  },
  methods: {
    // 禁用不可选线
    selectable(row) {
      // 过滤掉自己这列选择的
      const list = this.value ? this.value.split(',') : []
      return !(this.disabledIds.indexOf(row.id) > -1 && !(list.indexOf(row.id) > -1))
    },
    setSelect(list) {
      this.$refs.table.clearSelection()
      list.forEach((row) => {
        this.$refs.table.toggleRowSelection(row)
      })
    },
    clearName() {
      this.paperName = ''
      this.$emit('change', '')
      this.$emit('changeSelectionData', [])
    },
    // 获取用户名
    async getPaperName() {
      const list = this.value ? this.value.split(',') : []
      if (!list.length) {
        return
      }
      //   const [err, res] = await examPaperApi.getUserDetail({ id })
      // 没有ids接口目前先多次请求 待优化
      const promiseList = list.map((id) => {
        return examPaperApi.get(id)
      })
      const resultList = await Promise.all(promiseList)
      const items = resultList.map((item) => {
        const [err, res] = item
        return res
      })
      this.paperName = items
        .map((item) => {
          return item.paperName
        })
        .join(',')
      this.setSelect(items)
    },
    // 初始化弹窗
    initDialog() {
      this.searchData = this.$options.data().searchData
      this.showDialog = true
      this.getPaperList()
    },
    // 选中结果事件
    handleSelection(values) {
      if (this.multiple) {
        this.selectionData = values
      }
    },
    getRowKeys(row) {
      return row.id
    },
    cellClick(row) {
      if (!this.multiple) {
        this.paperName = row.paperName
        this.$emit('change', row.id)
        this.$emit('changeSelectionData', [row])
        this.showDialog = false
      }
    },
    handleOk() {
      this.paperName = this.selectionData
        .map((item) => {
          return item.paperName
        })
        .join()
      const ids = this.selectionData
        .map((item) => {
          return item.id
        })
        .join()
      this.$emit('change', ids)
      this.$emit('changeSelectionData', this.selectionData)
      this.showDialog = false
    },
    clearSearchName() {
      this.getPaperList()
    },
    // 人员搜索
    handleSearch() {
      this.pageConfig.SkipCount = 1
      this.getPaperList()
    },
    resetText() {
      this.searchData = this.$options.data().searchData
      this.handleSearch()
    },
    // 获取用户列表
    async getPaperList() {
      const searchData = utils.deleteFormField(this.searchData)
      const data = {
        maxResultCount: this.pageConfig.MaxResultCount, // 每页多少条
        skipCount: (this.pageConfig.SkipCount - 1) * this.pageConfig.MaxResultCount, // 跳过多少条
        ...searchData,
      }
      this.tableLoading = true
      const [err, res] = await examPaperApi.pagedListQuery(data)
      if (!err) {
        this.tableData = res.items
        this.total = res.totalCount
      }
      this.tableLoading = false
    },
    // 页码改变
    tableSizeChange(MaxResultCount) {
      this.pageConfig.MaxResultCount = MaxResultCount
      this.getPaperList()
    },
    // 页数改变
    tableCurrentChange(SkipCount) {
      this.pageConfig.SkipCount = SkipCount
      this.getPaperList()
    },
  },
  created() {
    utils.getDataCategory(
      ['ExamManagement.DataCategory.ExamPapersClassification'],
      ['pagerTypeList'],
      this
    )
    this.getPaperList()
  },
  mounted() {
    // 强制加载dialog中的内容
    this.showDialog = true
    this.$refs.dailog.rendered = true
    this.showDialog = false
  },
}
</script>

<style scoped lang="scss">
.tree {
  height: calc(100% - 74px);
  ::v-deep .el-tree-node__content {
    height: 35px;
    .node-item {
      width: calc(100% - 24px);
      .custom-tree-node {
        display: flex;
        align-items: center;
        font-size: 14px;
      }
    }
  }
}
::v-deep .el-select-dropdown__item {
  background-color: #ffffff !important;
  overflow: hidden;
  flex-wrap: nowrap;
}
::v-deep .el-card__body {
  height: 100%;
}
::v-deep .el-input__validateIcon {
  display: none;
}
.vertial-border {
  background-color: #0086f7;
}
</style>
